import { MutationTree } from 'vuex';
import { AuthenticationState } from './types';

export const mutations: MutationTree<AuthenticationState> = {
    loggedIn(state, payload: any) {
        state.error = false;
        state.jwt = payload.jwt;
    },
    logginError(state, error: any) {
        state.error = true;
        state.jwt = undefined;
    },
    logout(state) {
        state.jwt = undefined;
    },
    saveUser(state, payload: any) {
        state.user = payload;
    },
};
